import React, { SyntheticEvent, useState } from "react";

import { dropListProps, inputProps } from "../../@types/assetTypes/ap";
import Button from "../../components/Button";
import Dropdown from "../../components/Dropdown/index";
import FileUpload from "../../components/FileUpload";
import Input from "../../components/Input";
import Textlabel from "../../components/Textlabel";
import { getCurrentEnv } from "../../constants/env";

export interface InitiateProps {
  isIncludeError: boolean;
  inputVal: inputProps;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isExcludeError: boolean;
  inputDisabled: boolean;
  handleSubmit: (e: SyntheticEvent) => void;
  buttonDisabled: boolean;
  handleGeneratePDF: (
    e: SyntheticEvent,
    client: dropListProps,
  ) => Promise<boolean>;
}

const adhocAcceptedFormats = [".xls", ".xlsx"];

const adhocClientList: dropListProps[] = [
  {
    id: process.env[`REACT_APP_${getCurrentEnv()}_MCKINSEY_CLIENT_ID`] || "",
    name: "McKinsey",
  },
];

const Initiatesection: React.FC<InitiateProps> = ({
  isIncludeError,
  inputVal,
  handleChange,
  isExcludeError,
  inputDisabled,
  handleSubmit,
  buttonDisabled,
  handleGeneratePDF,
}) => {
  const [adhocClientVal, setAdhocClientVal] = useState<dropListProps>(
    adhocClientList[0] || {},
  );

  const handleAdhocClientChange = (value: dropListProps): void => {
    const _adhocClientVal = { ...adhocClientVal, ...value };

    if (value.name !== adhocClientVal.name) {
      _adhocClientVal.file = undefined;
    }

    setAdhocClientVal(_adhocClientVal);
  };

  const handleAdhocFileUpload = (file: File): void => {
    setAdhocClientVal({ ...adhocClientVal, file });
  };

  const closeAdhocFileUpload = (): void => {
    setAdhocClientVal({ ...adhocClientVal, file: undefined });
  };

  const [isGenerating, setIsGenerating] = useState(false);

  const generatePdfDisabled =
    !(adhocClientVal.name && adhocClientVal.file) || isGenerating;

  const onGeneratePDF = async (e: SyntheticEvent): Promise<void> => {
    setIsGenerating(true);

    try {
      const success = await handleGeneratePDF(e, adhocClientVal);

      if (success) setAdhocClientVal(adhocClientList[0] || {});
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="p-10 shadow-custom">
      <div className="flex flex-row justify-center items-stretch gap-10">
        <form className="flex flex-col items-center gap-10 w-full">
          <div className="w-full flex justify-center">
            <Input
              nameVal="includedInvoices"
              placeholder="Invoices range and/or comma separated eg: 100-200,304"
              inputValue={inputVal.includedInvoices || ""}
              changeHandler={handleChange}
              inputTitle="Invoices to Include"
              isInputError={isIncludeError}
              styleVal="w-3/4"
            />
          </div>
          <div className="w-full flex justify-center">
            <Input
              isInputError={isExcludeError}
              nameVal="excludedInvoices"
              placeholder="Invoices range and/or comma separated eg: 100-200,304"
              inputValue={inputVal.excludedInvoices || ""}
              changeHandler={handleChange}
              inputTitle="Invoices to Exclude"
              inputDisable={inputDisabled}
              styleVal="w-3/4"
            />
          </div>
          <div className="mx-auto">
            <Button
              label="Generate Invoice"
              type="submit"
              onClick={handleSubmit}
              disabled={buttonDisabled}
            />
          </div>
        </form>
        <div className="w-px bg-gray-300" />
        <div className="flex flex-none">
          <div className="flex flex-col items-start justify-center w-fit mx-auto gap-10">
            <div className="flex flex-col gap-2">
              <Textlabel label="Client" mandatory styleVal="px-0" />
              <Dropdown
                arrayList={adhocClientList}
                changeHandler={handleAdhocClientChange}
                value={adhocClientVal}
                styleObj={{ width: "230px" }}
              />
            </div>
            <div className="flex flex-col gap-2">
              <Textlabel label="Upload File" mandatory styleVal="px-0" />
              <FileUpload
                acceptedFormats={adhocAcceptedFormats}
                handleFileUpload={handleAdhocFileUpload}
                selectedFile={adhocClientVal.file}
                onClearFile={closeAdhocFileUpload}
                styleVal="w-[230px] h-[102px]"
              />
            </div>
            <div className="mt-4 mx-auto">
              <Button
                label="Generate Invoice PDF"
                type="button"
                onClick={onGeneratePDF}
                disabled={generatePdfDisabled}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Initiatesection;
